import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '.Mui-selected': {
        backgroundColor: '#A7D2FF!important',
        '&:hover': {
          backgroundColor: '#A7D2FF!important',
        },
      },
      '.MuiMenuItem-root:hover': {
        backgroundColor: 'rgba(48, 150, 255, 0.24)!important',
      },
      '.MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: '#A7D2FF!important',
      },
      '.MuiMenu-list, .MuiAutocomplete-listbox': {
        border: '2px solid #818D9E',
        borderRadius: 12,
        marginTop: 8,
        backgroundColor: '#FFF',
      },
      '.MuiMenu-paper': {
        backgroundColor: 'transparent',
      },
      '.Mui-checked': {
        color: '#3096FF!important',
      },
    },
  }),
);

export default useStyles;
